module.exports = __webpack_public_path__ + "img/uncollect.d451063e.svg";